document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.aivayi-sticky-atc').forEach((bar) => {
    const sectionId = bar.dataset.sectionId;
    const trigger = document.getElementById('ProductSubmitButton-' + sectionId);
    if (!trigger) return;

    const stickyButton = bar.querySelector('[data-sticky-atc-trigger]');
    if (stickyButton) {
      stickyButton.addEventListener('click', () => trigger.click());
    }

    const observeTarget = trigger.closest('.product-form__buttons') || trigger;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const visible = !entry.isIntersecting;
          bar.classList.toggle('is-visible', visible);
          bar.setAttribute('aria-hidden', String(!visible));
        });
      },
      { threshold: 0 }
    );
    observer.observe(observeTarget);
  });
});
